<template>
    <DefaultLayout :title="__('admin::general.edit_model', {'model': modelNameSingular.toLowerCase() })">

        <template #title>
            <InertiaLink :href="indexRoute">{{ modelNamePlural }}</InertiaLink>
            <ChevronRightIcon class="w-6 h-6 inline align-text-top text-gray-300" />
            {{ name}}
        </template>

        <template #default>

            <slot name="tabs" />

            <Panel>

                <form @submit.prevent="submit">

                    <slot></slot>

                    <Button :loading="form.processing">
                        {{ __('admin::general.update_model', {'model': modelNameSingular.toLowerCase() }) }}
                    </Button>

                </form>

            </Panel>

        </template>

    </DefaultLayout>

</template>

<script>
    import { ChevronRightIcon } from '@heroicons/vue/outline'

    export default {
        components: {
            ChevronRightIcon,
        },
        props: {
            indexRoute: String,
            editRoute: String,
            updateRoute: String,
            modelNameSingular: String,
            modelNamePlural: String,
            form: Object,
            name: String,
            translatable: Object,
        },
        methods: {
            submit() {
                this.form
                    .transform((data) => ({
                        ...data,
                        _method: 'patch',
                        _locale: this.translatable ? this.translatable.language.locale : null,
                    }))
                    .post(this.updateRoute);
            }
        },
    }
</script>
